/**
 * Admin API Service
 * Handles admin-only API calls for job management and card stats.
 */

import { API_URL } from '../config';

const adminHeaders = (authToken) => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${authToken}`,
});

export const adminApi = {
  async triggerJob(authToken, options = {}) {
    const response = await fetch(`${API_URL}/api/admin/jobs`, {
      method: 'POST',
      headers: adminHeaders(authToken),
      body: JSON.stringify({
        job_type: options.jobType || 'full',
      }),
    });
    if (!response.ok) throw new Error(`Failed to trigger job: ${response.status}`);
    return response.json();
  },

  async getJobStatus(authToken, jobId) {
    const response = await fetch(`${API_URL}/api/admin/jobs/${jobId}`, {
      headers: adminHeaders(authToken),
    });
    if (!response.ok) throw new Error(`Failed to get job: ${response.status}`);
    return response.json();
  },

  async listJobs(authToken) {
    const response = await fetch(`${API_URL}/api/admin/jobs`, {
      headers: adminHeaders(authToken),
    });
    if (!response.ok) throw new Error(`Failed to list jobs: ${response.status}`);
    return response.json();
  },

  async getCardStats(authToken) {
    const response = await fetch(`${API_URL}/api/admin/cards/stats`, {
      headers: adminHeaders(authToken),
    });
    if (!response.ok) throw new Error(`Failed to get card stats: ${response.status}`);
    return response.json();
  },

  async deleteCard(authToken, cardId) {
    const response = await fetch(`${API_URL}/api/admin/cards/${cardId}`, {
      method: 'DELETE',
      headers: adminHeaders(authToken),
    });
    if (!response.ok) throw new Error(`Failed to delete card: ${response.status}`);
    return response.json();
  },
};

export default adminApi;
